import React, { Suspense } from 'react';
import '@src/i18n';
import { ErrorScreenCtxProvider } from '@shared/context/error-screen';
import { NotificationsCtxProvider } from '@shared/context/notifications';
import { CurrentUserCtxProvider } from '@src/shared/context/current-user';
import { KeycloakUserCtxProvider } from '@src/shared/context/keycloak-user';
import ContentDomain from '@shared/components/ContentDomain';
import SplashScreen from './shared/components/SplashScreen';
import { DeliveryNavigationCtxProvider } from './pages/Deliveries/context/delivery-navigation';

import DynamicTheme from './pages/Deliveries/components/DynamicTheme';
import ErrorScreen from './shared/components/ErrorScreen';
import { MobileViewCtxProvider } from './shared/context/mobile-view';
import { FeatureFlaggingCtxProvider } from '@src/shared/context/featureflaging';
import { InsideDrawerCtxProvider } from './shared/context/inside-drawer';
import { TutorialCtxProvider } from './shared/context/tutorial';
import JetFMWrapper from './shared/components/JetFMWrapper';
import { PermissionConsentCtxProvider } from './shared/context/permission-consent';
import { AnalyticsContainer } from './tracking/components/AnalyticsContainer';

/* HIDE Get Feedback on load */
(window as any).usabilla_live('hide');
export const App = () => {
  return (
    <Suspense fallback={<SplashScreen />}>
      <ErrorScreenCtxProvider>
        <AnalyticsContainer>
          <InsideDrawerCtxProvider>
            <PermissionConsentCtxProvider>
              <TutorialCtxProvider>
                  <NotificationsCtxProvider>
                    <CurrentUserCtxProvider>
                      <KeycloakUserCtxProvider>
                        <JetFMWrapper>
                          <DynamicTheme>
                            <ErrorScreen />
                            <FeatureFlaggingCtxProvider>
                              {/*  <!-- TODO Refactor --> */}
                              <MobileViewCtxProvider>
                                <DeliveryNavigationCtxProvider>
                                  <ContentDomain />
                                </DeliveryNavigationCtxProvider>
                              </MobileViewCtxProvider>
                            </FeatureFlaggingCtxProvider>
                          </DynamicTheme>
                        </JetFMWrapper>
                      </KeycloakUserCtxProvider>
                    </CurrentUserCtxProvider>
                  </NotificationsCtxProvider>
              </TutorialCtxProvider>
            </PermissionConsentCtxProvider>
          </InsideDrawerCtxProvider>
        </AnalyticsContainer>
      </ErrorScreenCtxProvider>
    </Suspense>
  );
};

export default App;
